import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CATEGORIES, FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { __ } from '@design-system/i18n';
import { ScreenReadersContent } from '@design-system/screen-readers-content';
import { Dropdown } from './Dropdown';
export const DropdownThreeDotsIcon = (_a) => {
    var { screenReadersText = __('Open dropdown') } = _a, props = __rest(_a, ["screenReadersText"]);
    return (_jsxs(Dropdown, Object.assign({}, props, { children: [_jsx(ScreenReadersContent, { children: screenReadersText }), _jsx(FontAwesomeIcon, { height: "18px", iconName: "ellipsis", iconType: CATEGORIES.SOLID })] })));
};
//# sourceMappingURL=DropdownThreeDotsIcon.js.map